import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IDonorProfileAcceptsData, IDonorProfileDeclinesData, IDonorProfilePreSelectLogData } from '@nkr/models/index';

export interface IDonorProfileDeclinesResponse {
    data: {
        success: boolean,
        results: IDonorProfileDeclinesData
    }
}

export interface IDonorProfileAcceptsResponse {
    data: {
        success: boolean,
        results: IDonorProfilePreSelectLogData
    }
}

export const ActionCreators = {
    getProfileDeclinesData: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileDeclinesResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/declines`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getProfileAcceptsData: (donorId: number, centerId: number, isMatchResults: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileAcceptsResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/accepts?isMatchResults=${isMatchResults}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
}